import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { UserContext } from '@eas/common-web';
import { Login } from './modules/login/Login';

export function AppPublic() {
  const { user } = useContext(UserContext);

  return (
    <>
      {user ? (
        <Redirect to={window.sessionStorage.getItem('redirectTo') ?? '/'} />
      ) : (
        <Login />
      )}
    </>
  );
}
